<template>
  <div>
    <div class="row align-items-end mb-3">
      <div class="col-md-5 col-sm-12">
        <label class="form-label font-weight-bold">Diagnóstico CIE-10</label>
        <v-select-dx v-model="selectedDx" mode="object"></v-select-dx>
      </div>
      <div class="col-md-3 col-sm-6">
        <label class="form-label font-weight-bold">Parentesco</label>
        <select v-model="selectedParentescoId" class="form-control form-control-sm">
          <option :value="null">Seleccione...</option>
          <option v-for="p in parentescos" :key="p.id" :value="p.id">
            {{ p.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-2 col-sm-6">
        <label class="form-label font-weight-bold">Lado Familiar</label>
        <select v-model="selectedLado" class="form-control form-control-sm">
          <option :value="null">Seleccione...</option>
          <option value="Paterno">Paterno</option>
          <option value="Materno">Materno</option>
          <option value="Ambos">Ambos</option>
          <option value="Ninguno">Ninguno</option>
        </select>
      </div>
      <div class="col-md-2 col-sm-12">
        <button type="button" class="btn btn-primary btn-sm btn-block" @click="addFamilyDetail">
          <i class="fa fa-plus fa-fw"></i> Agregar
        </button>
      </div>
    </div>

    <div v-if="value.length > 0" class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead class="bg-light">
          <tr>
            <th>CIE-10</th>
            <th>Diagnóstico</th>
            <th>Parentesco</th>
            <th>Lado Familiar</th>
            <th class="text-center" style="width: 50px;">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in value" :key="index">
            <td>{{ item.ID_DIAG }}</td>
            <td>{{ (item.diagnostico ? item.diagnostico.DESC_DIAG : item.diagnostico_desc) || item.ID_DIAG }}</td>
            <td>{{ getParentescoName(item.parentesco_id) }}</td>
            <td>{{ item.lado_familiar || 'N/A' }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-danger btn-xs" @click="removeFamilyDetail(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ServiceFactory from "../../services/ServiceFactory";
const ParentescoService = ServiceFactory.get("parentesco");
import VSelectDx from "../../components/common/VSelectDx.vue";

export default {
  name: 'FamilyHistoryDetail',
  components: { VSelectDx },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      parentescos: [],
      selectedDx: null,
      selectedParentescoId: null,
      selectedLado: null
    };
  },
  mounted() {
    this.fetchParentescos();
  },
  methods: {
    async fetchParentescos() {
      try {
        const response = await ParentescoService.index();
        this.parentescos = response.data;
      } catch (e) {
        console.error('Error fetching parentescos:', e);
      }
    },
    addFamilyDetail() {
      if (!this.selectedDx) return;

      const newDetail = {
        tipo_detalle: 'FAMILY_HISTORY',
        ID_DIAG: this.selectedDx.ID_DIAG,
        diagnostico_desc: this.selectedDx.DESC_DIAG,
        parentesco_id: this.selectedParentescoId,
        lado_familiar: this.selectedLado
      };

      this.$emit('input', [...this.value, newDetail]);
      
      this.selectedDx = null;
      this.selectedParentescoId = null;
      this.selectedLado = null;
    },
    removeFamilyDetail(index) {
      const updated = [...this.value];
      updated.splice(index, 1);
      this.$emit('input', updated);
    },
    getParentescoName(id) {
      const p = this.parentescos.find(x => x.id === id);
      return p ? p.nombre : 'N/A';
    }
  }
};
</script>
